module.exports = __webpack_public_path__ + "img/cxx.4a8c004b.png";